// extracted by mini-css-extract-plugin
module.exports = {"TaxExemptionsList":"TaxExemptionsList_TaxExemptionsList__2y-WJ","periodText":"TaxExemptionsList_periodText__NLgZc"};